import { LenderName } from '@nemuru-eng/js-api-client';
import { useMemo, useState } from 'react';

import { LenderIcons } from '@/components/modules/Application/components/PaymentMethod/_shared/components/LenderIcons';
import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { ProcessingStrategy } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/ProcessingStrategy';
import { AbstractLoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/entities/PaymentMethodDetail/AbstractLoanPaymentMethodDetailEntity';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { LaunchButton } from '@/components/shared/components/LaunchButton';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface ProcessingStrategyButtonProps {
  paymentMethodDetailEntity: AbstractLoanPaymentMethodDetailEntity;
}

export const ProcessingStrategyButton = ({ paymentMethodDetailEntity }: ProcessingStrategyButtonProps) => {
  const { refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();

  const { sm } = useScreen();

  const [open, setOpen] = useState(false);

  const allLenders = useMemo(() => {
    if (!paymentMethodDetailEntity.paymentMethod) return;
    const allProviders = paymentMethodDetailEntity.paymentMethod.getAllProviderNames();
    // Filter out external providers from multi-lender
    if (allProviders.length > 1) {
      return allProviders.filter((provider) => provider !== LenderName.FINONLINE);
    }
    return allProviders;
  }, [paymentMethodDetailEntity]);

  const handleOpen = (opened: boolean) => {
    if (opened === false) {
      refreshCheckoutSessionAndPaymentMethodEntities();
    }
    setOpen(opened);
  };

  const loan = paymentMethodDetailEntity.loan;

  const disabled =
    paymentMethodDetailEntity.loanApplicationIds === undefined ||
    paymentMethodDetailEntity.loanApplicationIds.length === 0;

  const onClick = () => {
    if (disabled) return;
    setOpen(true);
  };

  return (
    <>
      <FlexRow justifyContent="flex-start" gridGap={2}>
        {allLenders && (
          <LenderIcons
            allLenderNames={allLenders as LenderName[]}
            activeLenderNames={loan?.loanApplicationSelected ? [loan.loanApplicationSelected.lenderName] : []}
            size={24}
          />
        )}
        {!disabled && <LaunchButton tId={'SEE_MORE'} onClick={onClick} />}
      </FlexRow>
      <NemuruDialog
        opened={open}
        setOpened={handleOpen}
        titleTextElement={<Text tId={sm ? 'PROCESSING_STRATEGY' : 'PROCESSING_STRATEGY_MOBILE'} />}
        dialogProps={{ maxWidth: false }}
        paperProps={{ maxWidth: 880 }}
      >
        <ProcessingStrategy paymentMethodDetailEntity={paymentMethodDetailEntity} onError={() => setOpen(false)} />
      </NemuruDialog>
    </>
  );
};
